import { observable } from "mobx";
import NotificationPreferences from "../models/notificationPreferences";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.

export default class PutChargeContactResult {
  @observable
  authCode?: string;

  @observable
  emailAddress?: string;

  @observable
  notificationPreferences?: NotificationPreferences;
}
